import { render } from "./Stake.htm?vue&type=template&id=1f2f6481&scoped=true"
import script from "./Stake.js?vue&type=script&lang=js"
export * from "./Stake.js?vue&type=script&lang=js"

import "./Stake.scss?vue&type=style&index=0&id=1f2f6481&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2f6481"]])

export default __exports__